import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix default marker asset URLs under the CRA/webpack bundler.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// A clean pin: white teardrop with a coloured dot. `color` is any CSS color
// (we pass the resolved orange primary token for delivery pins).
export const makePinIcon = (color = 'hsl(20 90% 48%)', size = 38) => L.divIcon({
  className: 'rmp-pin',
  html: `
    <div style="position:relative;width:${size}px;height:${size}px;transform:translateY(-2px);">
      <div style="position:absolute;left:50%;top:0;transform:translateX(-50%);width:${size * 0.7}px;height:${size * 0.7}px;
        background:#fff;border-radius:50% 50% 50% 0;transform-origin:center;rotate:45deg;
        box-shadow:0 3px 8px rgba(0,0,0,.35);border:2px solid ${color};"></div>
      <div style="position:absolute;left:50%;top:${size * 0.34}px;transform:translate(-50%,-50%);width:${size * 0.32}px;height:${size * 0.32}px;
        background:${color};border-radius:50%;"></div>
    </div>`,
  iconSize: [size, size],
  iconAnchor: [size / 2, size - 6],
  popupAnchor: [0, -size + 6],
});

// A pulsing courier marker (dark center, coloured ring).
export const makeCourierIcon = (color = 'hsl(20 90% 48%)') => L.divIcon({
  className: 'rmp-courier',
  html: `
    <div style="position:relative;width:26px;height:26px;">
      <span style="position:absolute;inset:0;border-radius:50%;background:${color};opacity:.25;animation:rmpPulse 1.6s ease-out infinite;"></span>
      <span style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:16px;height:16px;border-radius:50%;
        background:#1a1a1a;border:3px solid ${color};box-shadow:0 1px 4px rgba(0,0,0,.4);"></span>
    </div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 13],
});

export default L;
